import { isDate, times } from 'lodash'
import { padZero } from '@/utils/number'

const TIME_REGEX = /(\d+)[:：]?(\d{2})/

export function toTimeObject(time) {
  if (!time) return {}
  if (isDate(time)) return { hour: padZero(time.getHours()), minute: padZero(time.getMinutes()) }
  const [, hour, minute] = TIME_REGEX.exec(time)
  return { hour, minute }
}

export function toMinutes(time) {
  const { hour = 0, minute = 0 } = toTimeObject(time)
  return hour * 60 + +minute
}

/**
 * 時刻フォーマットします
 */
export function formatTime(time, separator = '：') {
  if (!time) return time
  const [, hour, minute] = TIME_REGEX.exec(time)
  return `${+hour}${separator}${padZero(minute)}`
}

/**
 * フォーマットを解除します
 */
export function normalizeTime(str) {
  if (!str) return str
  const [, hour, minute] = TIME_REGEX.exec(str)
  return `${padZero(hour)}${minute}`
}

export function minutesToTime(minutes) {
  return `${padZero(Math.floor(minutes / 60))}:${padZero(minutes % 60)}`
}

/**
 * 開始時間から終了時間までの配列を返します
 *
 * @param {*} start 開始時間
 * @param {*} end 終了時間
 */
export function eachTime(start, end, interval = 15) {
  if (!start || !end) return []

  start = toMinutes(start)
  end = toMinutes(end) + interval

  return times((end - start) / interval, i => minutesToTime(start + i * 15))
}

/**
 * 時間の配列から、連続する時間を範囲 { start, end } としてまとめます。
 *
 * @param {array} timesArr 時間の配列
 * @param {number=3} minTimes まとめる始める連続する時間
 * @param {interval=15} interval まとめる始める時間間隔
 * @returns {arrray} 時間範囲の配列
 */
export function timesToRanges(timesArr = [], minTimes = 3, interval = 15) {
  return timesArr
    .reduce((groups, time, i) => {
      if (toMinutes(time) - toMinutes(timesArr[i - 1]) > interval) {
        groups.push([time])
      } else {
        groups[groups.length - 1].push(time)
      }
      return groups
    }, [])
    .reduce(
      (ranges, group) =>
        ranges.concat(
          group.length >= minTimes
            ? { start: group[0], end: group[group.length - 1] }
            : group.map(time => ({ start: time })),
        ),
      [],
    )
}

export function minutesToJpNotation(minutes, halfReplace) {
  if (minutes === 0) return '0分'

  const hour = Math.floor(minutes / 60)
  const minute = minutes % 60

  const hourJp = hour !== 0 ? `${hour}時間` : ''
  const halfText = halfReplace ? '半' : `${minute}分`

  if (minute === 0) return hourJp

  if (minute !== 30) return hourJp + `${minute}分`

  return hourJp + (hour === 0 ? `${minute}分` : halfText)
}
